import Knowledge from '../components/Knowledge/Knowledge'
import home from '../components/Homepage';
import ChatContainer from '../components/Chat/ChatContainer';
import Chat from '../components/Chat/Chat';
import ChatWindow from '../components/Chat/ChatWindow';
import ApplicantChatList from '../components/Chat/ApplicantChatList';
// import Getaccess from '../components/Nearme/Getaccess';
import Getaccess from '../components/Nearme/Access';
import NewKnowledge from '../components/Knowledge/NewKnowledge';
import KnowledgeDetail from '../components/Knowledge/KnowledgeDetail';
import ChampionDetail from '../components/Knowledge/ChampionDetail';
import Settings from '../components/Settings/Settings';
import TermsAndConditions from '../components/Tos/TermsAndConditions';
import UserProfile from '../components/Settings/UserProfile';
import EmergencyContacts from '../components/Settings/EmergencyContacts';
import UserLogin from '../components/Settings/UserLogin';
import ResetPin from '../components/Settings/ResetPin';
import LoginPin from '../components/Settings/LoginPin';
import Information from '../components/Information/Information';
import InformationDetails from '../components/Information/Information';
import ResetPassword from '../components/Settings/ResetPassword'
import GroupChatList from '../components/Chat/GroupChatList';
import KnowYourRights from '../components/KnowYourRights/KnowYourRights';
import KnowYourRightsDetail from '../components/KnowYourRights/KnowYourRightsDetail';
import Services from '../components/Services/Services';
import ServicesChatWindow from '../components/Services/ServicesChatWindow';
import Survey from '../components/Survey/Survey';
import ServiceForm from '../components/Services/ServiceForm';
import SurveyForm from '../components/Survey/SurveyForm';
import SurveyCasePreview from '../components/Survey/SurveyCasePreview';
import ServicesCasePreview from '../components/Services/ServicesCasePreview';
// import Fox from '../components/Fox/Fox';
// import Box from '../components/Box/Box';

// import CalendarView from '../components/Calendar/CalendarView';
import CalendarPage from '../components/Calendar/CalendarPage';

import My404Component from '../components/Layout/My404Component';

import Mapfilterview from '../components/Nearme/maplistviewpagen.js';


// Some folks find value in a centralized route config.
// A route config is just data. React is great at mapping
// data into components, and <Route> is a component.

// Our route config is just an array of logical "routes"
// with `path` and `component` props, ordered the same
// way you'd do inside a `<Switch>`.
const routes = [
    {
        path: "/layout/getknowledgeable",
        name: "Get Knowledge",
        component: NewKnowledge
    },
    {
        path: "/layout/newgetknowledgeable",
        name: "NewKnowledge",
        component: NewKnowledge
    },
    {
        path: "/layout/gkchild",
        name: "GetKnowledgeChild ",
        component: NewKnowledge
    },
    {
        path: "/layout/getknowledgeableDetail",
        name: "Knowledge Detail",
        component: KnowledgeDetail
    },
    {
        path: "/layout/championdetail",
        name: "Champion Detail",
        component: ChampionDetail
    },
    {
        path: "/layout/knowyourrights",
        name: "KnowYourRights",
        component: KnowYourRights
    },
    {
        path: "/layout/kyrchild",
        name: "KnowYourRightsChild",
        component: KnowYourRights
    },
    {
        path: "/layout/getknowyourrightsdetail",
        name: "Know Your Detail",
        component: KnowYourRightsDetail
    },
    {
        path: "/layout/home",
        name: "Home",
        component: home
    },
    {
        path: "/layout/information",
        name: "Get Information",
        component: Information
    },
    {
        path: "/layout/informationdetails",
        name: "Information Detail",
        component: InformationDetails
    },
    {
        path: "/layout/getknowledgeable",
        name: "Get Information",
        component: NewKnowledge
    },
    {
        path: "/layout/getconnected",
        name: "Get Connected",
        component: ChatContainer
    },
    {
        path: "/layout/peerchat",
        name: "Chat List",
        component: ChatContainer
    },
    {
        path: "/layout/chatwindow",
        name: "Chat",
        component: ChatWindow
    },
    {
        path: "/layout/switch-to-peer",
        name: "Chat",
        component: ChatWindow
    },
    {
        path: "/layout/groupchat",
        name: "Group List",
        component: GroupChatList
    },
    {
        path: "/layout/nearme",
        name: "Get Access",
        component: Getaccess
    },
    {
        path: "/layout/Services",
        name: "Services",
        component: Services
    },
    {
        path: "/layout/ServicesChatWindow",
        name: "ServicesChatWindow",
        component: ServicesChatWindow
    },
    {
        path: "/layout/ServiceForm",
        name: "ServiceForm",
        component: ServiceForm
    },
    {
        path: "/layout/Survey",
        name: "Survey",
        component: Survey
    },
    {
        path: "/layout/SurveyForm",
        name: "SurveyForm",
        component: SurveyForm
    },
    {
        path: "/layout/SurveyCasePreview",
        name: "SurveyCasePreview",
        component: SurveyCasePreview
    },
    {
        path: "/layout/ServicesCasePreview",
        name: "ServicesCasePreview",
        component: ServicesCasePreview
    },
    {
        path: "/layout/Settings",
        name: "Settings",
        component: Settings
    },
    {
        path: "/layout/tos",
        name: "Tos",
        component: TermsAndConditions
    },
    {
        path: "/layout/UserProfile",
        name: "UserProfile",
        component: UserProfile
    },
    {
        path: "/layout/EmergencyContacts",
        name: "EmergencyContacts",
        component: EmergencyContacts
    },
    // {
    //     path: "/layout/fox",
    //     name: "Fox",
    //     component: Fox
    // },
    // {
    //     path: "/layout/box",
    //     name: "Box",
    //     component: Box
    // },
    {
        path: "/layout/userlogin",
        name: "userlogin",
        component: UserLogin
    },
    {
        path: "/layout/resetPin",
        name: "resetPin",
        component: ResetPin
    },
    {
        path: "/layout/loginPin",
        name: "loginPin",
        component: LoginPin
    },
    {
        path: "/layout/resetPassword",
        name: "resetPassword",
        component: ResetPassword
    },
    // {
    //     path: "/layout/CalendarView",
    //     name: "CalendarView",
    //     component: CalendarView
    // },
    {
        path: "/layout/CalendarView",
        name: "CalendarPage",
        component: CalendarPage
    },
     {
        path: "/layout/Mapfilterview",
        name: "Mapfilterview",
        component: Mapfilterview
    },
    {
        path: "*",
        name: "My404Component",
        component: My404Component
    },
    
    {
        default: '/layout',
        component: home
    },
];

export default routes;